export default "__VITE_ASSET__CIoPc_n2__"